
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gender-and-relationships",
      function () {
        return require("private-next-pages/gender-and-relationships.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gender-and-relationships"])
      });
    }
  